import { useMediaQuery } from "@mui/material";

export const useResponsive = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:960px)");
  const isCustomLayout = useMediaQuery("(max-width:1280px)");
  const isDesktoplayout = useMediaQuery("(min-width:1280px)");
  const isWideDesktop = useMediaQuery("(min-width:1500px)");
  const isUltraWideDesktop = useMediaQuery("(min-width:2000px)");
  const isDesktop = useMediaQuery("(min-width:961px)");
  const isLaptop = useMediaQuery("(min-width:1200px)");
  const isSmall = useMediaQuery("(max-width:899px)");
  const isLG = useMediaQuery("(min-width:1360px)");
  const isMD = useMediaQuery("(min-width:900px)");

  return {
    isMobile,
    isLaptop,
    isTablet,
    isDesktop,
    isCustomLayout,
    isSmall,
    isWideDesktop,
    isDesktoplayout,
    isUltraWideDesktop,
    isLG,
    isMD,
  };
};
